<script setup lang="ts">
definePageMeta({
  layout: 'empty'
})
</script>

<template>
  <NuxtPage/>
</template>

<style>
body {
  background-color: transparent;
}
</style>